import { useEffect, useState, useRef } from "react";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../Calendar/Calendar.css"
import './NewTabletBookingForm.css';
import { ErrorAlert } from '../../crud/utils';
import useApp from '../../AppContext';
import { loadListAllObjects, loadFormObject, getBookingSuppliers, getPorders, getBookingTasks, loadEditObject, getSuppliers, getDropdownLookupList, postBooking } from "../../Calendar/CalendarUtils";
import { getPropValue, setPropValue, createGql, callApi } from '../../crud/utils';
import TabletSuccMessage from "../Components/TabletSuccMessage";
import PhotoUpload from "../Components/PhotoUpload";
import AutoCompleteOneOutPut from "../../crud/AutoCompleteOneOutPut";
import { t } from "./../../i18n"
import ListSuppliers from "../../Calendar/ListSuppliers";
import { format } from 'date-fns';
import Loading from "../../Loading";
import CustomDropdown from "../../Components/CustomDropdown";

function NewBookingForm(props) {
    const app = useApp();
    const photoUploadRef = useRef(null);
    const handleSaveBookingRef = useRef(null);

    useEffect(() => {
        if (props.saveTriggered > 0) {
            handleSaveBookingRef.current?.();
        }
    }, [props.saveTriggered]);
    const [gridTop] = useState(app.gridTop);
    const [serverUrl] = useState(app.serverUrl);
    const [language] = useState(app.sessionToken?.Language);
    const [User3plId] = useState(app.sessionToken?.User3pl);
    const [userid] = useState(app.sessionToken?.UserId);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [bookingObj, setBookingObj] = useState({})
    const [lookUpInfo, setLookUpInfo] = useState(null);
    const [titleValue] = useState(t("entryWithBooking.successTitle", language));
    const [btnSuccessScreenValue] = useState(t("entryWithBooking.nextEntry", language));
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [isSuppliersModalOpen, setIsSuppliersModalOpen] = useState(false);
    const handleOpenSuppliersModal = () => setIsSuppliersModalOpen(true);
    const handleCloseSuppliersModal = () => setIsSuppliersModalOpen(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadObj, setIsLoadObj] = useState(false);
    const [savedBookingData, setSavedBookingData] = useState(null);
    const [hasDriverBan, setHasDriverBan] = useState(false);

    const { onValidationChange } = props;
    useEffect(() => {
        const isValid = !!(bookingObj?.Obj?.TruckId)
            && !!(bookingObj?.Obj?.DriverId)
            && !hasDriverBan
            && bookingObj["Yms_BookingTasks"]?.length > 0
            && !bookingObj["Yms_BookingTasks"]?.some(task => !task.YmsCat1?.Descr1 || task.YmsCat1.Descr1.trim() === '');
        onValidationChange?.(isValid);
    }, [bookingObj, hasDriverBan, onValidationChange]);

    const handleImagesChange = (url) => {
        setBookingObj(prev => {
            const copy = { ...(prev || {}) };
            if (!copy.Obj) copy.Obj = {};
            copy.Obj.PhotoPath = url;
            return copy;
        });
    };

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            setIsLoading(true);
            try {
                if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                    let allobj = await loadListAllObjects(serverUrl, props.userToken)
                    if (allobj) {
                        setAllColumnsObj(allobj);
                        setIsLoadObj(true);
                    }
                    const layoutBooking = await loadFormObject(serverUrl, props.userToken, "Yms_Booking");
                    if (layoutBooking) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBooking);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_Booking"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                    const layoutBookTasks = await loadFormObject(serverUrl, props.userToken, "Yms_BookingTasks");
                    if (layoutBookTasks) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBookTasks);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_BookingTasks"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        async function getYmsBooking() {
            if (!props?.bookingId) return;
            const objectName = "Yms_Booking";
            if (Object.keys(allColumnsObj).length === 0) return;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "filterName": "customfilter",
                "dontCash": "true"
            }
            let prms = [];
            let prmValues = {};
            if (props.actions === "NewBoocking") {
                defaultVariables["createNewRow"] = "true";
            }
            else {
                defaultVariables["appendFilter"] = "{BookingId} =?(;n;15;p_BookingId) ";
                prms.push({ "parameterName": "p_BookingId", "type": "" });
                prmValues["p_BookingId"] = Number(props.bookingId || 0);
            }
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {
                let resultobj = result.data[objectName];
                if (props.actions === "NewBoocking") {
                    const localDate = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    const localString = format(localDate, "yyyy-MM-dd'T'HH:mm")
                    resultobj[0]["WarehouseId"] = props.warehouseid
                    //  resultobj[0]["InDate"] = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    // resultobj[0]["FromDate"] = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    resultobj[0]["InDate"] = localString;
                    resultobj[0]["FromDate"] = localString;
                    resultobj[0]["BookingUserId"] = userid;
                    resultobj[0]["Yms3plId"] = User3plId;
                }

                let objEdit = {
                    Obj: resultobj[0],
                    rowRestrictions: result.rowRestrictions,
                    disabledFields: result.disabledFields
                }
                const resYmsBsu = await getBookingSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsBsu) {
                    objEdit["Yms_BookingSuppliers"] = resYmsBsu;
                }
                const resYmsPor = await getPorders(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsPor) {
                    objEdit["Yms_Porders"] = resYmsPor;
                }
                const resYmsSup = await getSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsSup) {
                    objEdit["Yms_Suppliers"] = resYmsSup;
                }
                const YmsBta = await getBookingTasks(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (YmsBta) {
                    objEdit["Yms_BookingTasks"] = YmsBta;
                }
                setBookingObj(objEdit)
            }
        }
        getYmsBooking();
    }, [allColumnsObj, serverUrl, userid, props.warehouseid, props.actions, props.selectTtimeSlot, app.sessionToken, props.userToken, props?.bookingId, User3plId]);

    async function addTask() {
        const objectName = "Yms_BookingTasks";
        let prms = [];
        let prmValues = {};
        const parentSelectedRow = bookingObj.Obj;
        let defaultVariables = {
            "instanceName": "m_yms_booking",
            "dontCash": "true"
        }
        defaultVariables["createNewRow"] = "true";
        defaultVariables["parentSelectedRow"] = parentSelectedRow;
        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
        if (result.data[objectName]) {

            setBookingObj(prev => {
                prev = { ...prev }
                if (!prev[objectName]) prev[objectName] = [];
                else prev[objectName] = [...prev[objectName]];
                prev[objectName].push(result.data[objectName][0]);
                return prev;
            });
        }
    };
    const deleteTask = (rowIndex) => {
        let tmpbookingObj = { ...bookingObj }
        tmpbookingObj["Yms_BookingTasks"].splice(rowIndex, 1)
        setBookingObj(tmpbookingObj);
    };
    async function handleSaveSuppliers() {

        const supUpdated = { ...bookingObj };
        const objectName = "Yms_BookingSuppliers";
        const suppliers = [...(supUpdated["Yms_Suppliers"] || [])];
        const bookingSuppliers = [...(supUpdated[objectName] || [])];
        if (suppliers.length > 1) {
            setErrorMessage(t('ModalBooking.selectOnlyOneSupplier', language));
            return;
        } else {
            setErrorMessage(null)
        }
        const availableSuppliers = bookingSuppliers.filter(
            bs => !suppliers.some(sup => sup.SupplierId === bs.SupplierId)
        );
        if (availableSuppliers) {
            for (let index = 0; index < availableSuppliers.length; index++) {
                const indsup = bookingSuppliers.findIndex(e => e.SupplierId === availableSuppliers[index].SupplierId);
                if (indsup > -1) {
                    bookingSuppliers.splice(indsup, 1);
                }
            }
        }
        for (let index = 0; index < suppliers.length; index++) {
            const indsup = bookingSuppliers.findIndex(e => e.SupplierId === suppliers[index].SupplierId)
            if (indsup > -1) { continue; }
            let prms = [];
            let prmValues = {};
            const parentSelectedRow = bookingObj.Obj;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "dontCash": "true"
            }
            defaultVariables["createNewRow"] = "true";
            defaultVariables["parentSelectedRow"] = parentSelectedRow;
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {

                let suprow = result.data[objectName][0];
                suprow.SupplierId = suppliers[index].SupplierId;
                suprow.SupplierCode = suppliers[index].SupplierCode;
                suprow.YmsSup1.Name1 = suppliers[index].Name1;
                suprow.YmsSup1.SocialSecurityNo = suppliers[index].SocialSecurityNo;
                bookingSuppliers.push(suprow);
            }
        }
        supUpdated[objectName] = bookingSuppliers;
        setBookingObj(supUpdated);
        if (suppliers && suppliers.length > 0) {
            setBookingObj(prev => ({
                ...prev,
                Yms_Porders: []
            }));
        }
        setIsSuppliersModalOpen(false);
    }
    function onSelectedSup() {
        const strSup = bookingObj["Yms_Suppliers"]?.map(rowSup => rowSup.SupplierCode)
            .filter(code => code !== null)
            .join(', ');
        return strSup;
    }
    const handleSelectSupplier = (supplier) => {
        setBookingObj(prev => {
            const updated = { ...prev };
            const suppliers = [...(updated["Yms_Suppliers"] || [])];

            const index = suppliers.findIndex(s => s.SupplierId === supplier.SupplierId);
            if (index > -1) {
                updated["Yms_Suppliers"] = [];
            } else {
                updated["Yms_Suppliers"] = [supplier];
            }
            return updated;
        });
    };

    const findSelectSupplier = (supplier) => {
        return bookingObj["Yms_Suppliers"]?.some(s => s.SupplierId === supplier.SupplierId);
    };

    async function handleSaveBooking() {
        if (!bookingObj?.Obj?.TruckId) {
            setError(t("tablet.noTruckError", language));
            return;
        }
        if (!bookingObj?.Obj?.DriverId) {
            setError(t("tablet.noDriverError", language));
            return;
        }
        if (hasDriverBan) {
            setError(t('tablet.cannotSaveWithBannedDriver', language));
            return;
        }
        if (!bookingObj["Yms_BookingTasks"] || bookingObj["Yms_BookingTasks"].length === 0) {
            setError(t("tablet.noTaskError", language));
            return;
        }
        const hasEmptyCategory = bookingObj["Yms_BookingTasks"]?.some(task =>
            !task.YmsCat1?.Descr1 || task.YmsCat1.Descr1.trim() === ''
        );

        if (hasEmptyCategory) {
            setError(t('ModalBooking.categoryRequired', language));
            return;
        }
        try {
            const finalPaths = await photoUploadRef.current?.applyPendingChanges();
            setError(null);
            const updatedBookingObj = {
                ...bookingObj,
                Obj: {
                    ...bookingObj.Obj,
                    Status: 6,
                    PhotoPath: finalPaths ?? bookingObj?.Obj?.PhotoPath ?? null
                }
            };

            const saveobj = await postBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", updatedBookingObj);
            setSavedBookingData(saveobj);
            if (saveobj) {
                setShowModal(true);
                setTimeout(() => {
                    window.location.href = '/tablet-view';
                }, 1700);
            }
        } catch (error) {
            setError(`Σφάλμα κατά την αποθήκευση: ${error?.message || error}`);
            console.error("Save booking error:", error);
        }
    }
    handleSaveBookingRef.current = handleSaveBooking;

    function handleCloseModalSuccessMes(e) {
        e?.preventDefault?.();
        setShowModal(false);
    }
    async function setObjectValue(objName, rowIndex, column, value, selectedIndex) {
        let obj = {};

        if (rowIndex === null) {
            obj = { ...bookingObj["Obj"] };
        } else {
            obj = { ...bookingObj[objName][rowIndex] };
        }
        let tmpObj = { ...obj };
        setPropValue(tmpObj, column.columnName, value);

        if (column.columnName === "FromDate") {
            tmpObj["InDate"] = value;
        }

        if (selectedIndex >= 0 && lookUpInfo[objName][column.columnName] && lookUpInfo[objName][column.columnName].keyFields) {
            for (let i = 0; i < lookUpInfo[objName][column.columnName].keyFields.length; i++) {
                let kf = lookUpInfo[objName][column.columnName].keyFields[i];
                if (selectedIndex === 0) {
                    tmpObj[kf.foreignField] = null;
                }
                else {
                    tmpObj[kf.foreignField] = lookUpInfo[objName][column.columnName].values[selectedIndex - 1][kf.primaryField];
                }
            };
        }
        let tmpbookingObj = { ...bookingObj }

        if (rowIndex === null) {
            tmpbookingObj["Obj"] = tmpObj;
        }
        else {
            tmpbookingObj[objName][rowIndex] = tmpObj;
        }
        if (column.columnName === "StampFlg") {
            tmpbookingObj["Obj"].StampFlg = value ? 1 : 0;
        }
        if (column.columnName === "YmsDri1.Name1") {
            tmpbookingObj["Obj"].YmsDri1.DriverCode = value.secondaryField;
            tmpbookingObj["Obj"].DriverId = value.pkField;
            tmpbookingObj["Obj"].YmsDri1.Name1 = value.lkpField;
        }
        if (column.columnName === "YmsTrk1.LicenseNo") {
            tmpbookingObj["Obj"].YmsTrk1.LicenseNo = value.lkpField;
            tmpbookingObj["Obj"].TruckId = value.pkField;
            tmpbookingObj["Obj"].YmsTrk1.Descr1 = value.secondaryField;
        }
        if (column.columnName === "YmsTrk1.LicenseNo" && value === "" && typeof props.setActions === "function") {
            props.setActions("NewBoocking");
            props.setArrivalId(null)
            props.setBookingId('0')
            props.setSocialSecurityNo(null)
            props.resetFormState()
        }

        setBookingObj(tmpbookingObj);
    }

    function createTextBox(obj, columnName, objName, rowIndex) {
        if (!allColumnsObj[objName] || !allColumnsObj[objName].columns) {
            return <Form.Control readOnly />;
        }

        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        if (!column) {
            return <Form.Control readOnly />;
        }

        let colValue = getPropValue(obj, column.columnName);
        return <Form.Control
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
        />;
    }
    function createTextBoxCommends(obj, columnName, objName, rowIndex) {
        if (!allColumnsObj[objName] || !allColumnsObj[objName].columns) {
            return <Form.Control as="textarea" rows={6} readOnly />;
        }

        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        if (!column) {
            return <Form.Control as="textarea" rows={6} readOnly />;
        }

        let colValue = getPropValue(obj, column.columnName);
        return <Form.Control
            as="textarea"
            rows={6}
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
        />;
    }

    function createCheckBox(obj, columnName, objName, rowIndex) {
        if (!allColumnsObj[objName] || !allColumnsObj[objName].columns) {
            return <Form.Check type="checkbox" disabled />;
        }

        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        if (!column) {
            return <Form.Check type="checkbox" disabled />;
        }

        return <Form.Check
            type="checkbox"
            checked={!!getPropValue(obj, column.columnName)}
            id={column.fieldName}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.checked)}
        />;
    }

    function createDropDownLookUpList(obj, columnName, objName, rowIndex) {
        if (!lookUpInfo[objName] || !lookUpInfo[objName][columnName]) return null;
        let column = lookUpInfo[objName][columnName].column;
        
        const options = lookUpInfo[objName][column.columnName].values.map(lkpObj => ({
            value: lkpObj[column.dropDownDisplay],
            label: lkpObj[column.dropDownDisplay]
        }));

        return (
            <CustomDropdown
                options={options}
                value={getPropValue(obj, column.columnName)}
                onChange={e => setObjectValue(objName, rowIndex, column, e.target.value, e.target.selectedIndex)}
                readonly={column.editNotAllowed === true}
                showEmptyOption={true}
                placeholder="Επιλέξτε..."
            />
        );
    }

    function createAutoCompleteGeneric({
        objName,
        rowIndex,
        disabledFieldsFlg,
        columnConfig,
        objectName,
        instanceName,
        lookupPrimaryField,
        lookupSecondaryField,
        setFieldsInBookingObj
    }) {
        const obj = rowIndex === null
            ? bookingObj["Obj"]
            : bookingObj[objName][rowIndex];

        const primaryVal = getPropValue(obj, columnConfig.columnName) || "";
        const secondaryVal = getPropValue(obj, columnConfig.secondaryField) || "";

        return (
            <AutoCompleteOneOutPut
                key={`${primaryVal}_${secondaryVal}`}
                as="AutoComplete"
                placeholder=""
                serverUrl={serverUrl}
                props={props}
                col={columnConfig}
                obj={{
                    ...obj,
                    [columnConfig.columnName]: primaryVal,
                    [columnConfig.secondaryField]: secondaryVal,
                }}
                onChange={async (e) => {

                    if (e && e.option && columnConfig.columnName === 'YmsDri1.Name1' && e.option.pkField) {
                        const driverName = e.option.lkpField;
                        try {
                            const objectName = "Yms_Drivers";
                            let prms = [{ "parameterName": "p_DriverId", "type": "" }];
                            let prmValues = { "p_DriverId": Number(e.option.pkField) };
                            let defaultVariables = {
                                "instanceName": "m_yms_drivers",
                                "filterName": "customfilter",
                                "appendFilter": "{DriverId} =?(;n;15;p_DriverId)",
                                "dontCash": "true"
                            };

                            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                            const driver = result?.data?.[objectName]?.[0];
                            const isActive = driver?.ActiveFlg === true;
                            if (driver && !isActive) {
                                setError(`${t("tablet.driver", language)} "${driverName}" ${t("tablet.driverBan", language)}`);
                                setHasDriverBan(true);
                                let tmpbookingObj = { ...bookingObj };
                                tmpbookingObj["Obj"].DriverId = null;
                                tmpbookingObj["Obj"].YmsDri1.Name1 = "";
                                tmpbookingObj["Obj"].YmsDri1.DriverCode = "";
                                setBookingObj(tmpbookingObj);
                                return;
                            }
                            setHasDriverBan(false);
                        } catch (err) {
                            console.error("Error checking driver ActiveFlg:", err);
                        }
                    }

                    if (e && e?.option?.secondaryField === '') {
                        let prms = [];
                        let prmValues = {};
                        const parentSelectedRow = bookingObj.Obj;
                        let defaultVariables = {
                            instanceName: instanceName,
                            dontCash: "true",
                            createNewRow: "true",
                            parentSelectedRow: parentSelectedRow
                        };

                        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                        const rawData = result?.data?.[objectName]?.[0] || {};
                        let tmprawData = { ...rawData };
                        if (columnConfig.columnName === 'YmsDri1.Name1') {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = tmprawData.DriverId;
                        } else {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = `Εκκρεμής ${columnConfig.descr}`;
                        }


                        const gqlCols = createGql("", allColumnsObj[objectName].columns, []);
                        const requestBody = {
                            query: `mutation save${objectName}($obj: ${objectName}!){` +
                                `save${objectName}(${objectName}: $obj) ${gqlCols.query} }`,
                            variables: {
                                obj: {
                                    instanceName: '',
                                    filterName: "default",
                                    top: gridTop,
                                    changedData: [
                                        {
                                            action: "insert",
                                            original: null,
                                            current: tmprawData
                                        }
                                    ]
                                }
                            }
                        };
                        const gqlResult = await callApi('POST', `${serverUrl}/api/query`, props.userToken, requestBody);
                        const newEntry = gqlResult.data[objectName][0];

                        let tmpbookingObj = { ...bookingObj };
                        setFieldsInBookingObj(tmpbookingObj, newEntry);
                        setBookingObj(tmpbookingObj);
                        return;
                    }

                    setObjectValue(objName, rowIndex, columnConfig, e ? e.option : "");
                }}
                disabled={disabledFieldsFlg}
            />
        );
    }
    if (isLoading) return <Loading />;
    if (!isLoadObj) return;
    return (
        <div>
            {showModal && (
                <div className="modal-container-tablet">
                    <div className="modal-content-container-tablet">
                        <button onClick={handleCloseModalSuccessMes} className='close-btn-modal-tablet'>
                            <i className="bi bi-x-lg"></i>
                        </button>

                        <TabletSuccMessage
                            title={titleValue}
                            paragraph={
                                <>
                                    {savedBookingData.ArrivalId && (
                                        <>
                                            {t("ModalBooking.codeForEntry", language)}:<strong>{savedBookingData.ArrivalId}</strong>
                                        </>
                                    )}
                                </>
                            }
                            btnSuccessScreen={btnSuccessScreenValue}
                        />


                    </div>
                </div>
            )}
            <>
                <ErrorAlert message={error} setMessage={setError} language={language}/>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{(t('ModalBooking.supplierTitleForm', language))}</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={(t('ModalBooking.supplierPlaceholder', language))}
                            value={onSelectedSup()}
                            readOnly
                            onClick={handleOpenSuppliersModal}
                            style={{ cursor: bookingObj["Yms_Porders"]?.length > 0 ? "not-allowed" : "pointer", backgroundColor: "#fff" }}
                        />
                    </Form.Group>
                    <Row className="mb-3">
                        <Col md={9}>
                            <Form.Group>
                                <Form.Label>{t("ModalBooking.licenseNoTitleForm", language)}  <b className="required-bullet">*</b></Form.Label>
                                {createAutoCompleteGeneric({
                                    objName: "Yms_Booking",
                                    rowIndex: null,
                                    disabledFieldsFlg: props.disabledFieldsFlg,
                                    columnConfig: {
                                        descr: "πινακίδα",
                                        columnName: "YmsTrk1.LicenseNo",
                                        dropDownDisplay: "LicenseNo",
                                        lookUpQuery: "{Yms_Trucks{TruckId LicenseNo Descr1}}",
                                        secondaryField: "YmsTrk1.Descr1"
                                    },
                                    objectName: "Yms_Trucks",
                                    instanceName: "m_yms_trucks",
                                    lookupPrimaryField: "LicenseNo",
                                    lookupSecondaryField: "Descr1",
                                    setFieldsInBookingObj: (tmpObj, newEntry) => {
                                        tmpObj["Obj"].YmsTrk1.LicenseNo = newEntry.LicenseNo;
                                        tmpObj["Obj"].TruckId = newEntry.TruckId;
                                        tmpObj["Obj"].YmsTrk1.Descr1 = newEntry.Descr1;
                                    }
                                })}
                            </Form.Group>
                        </Col>
                        <Col md={3} className="d-flex align-items-end">
                            <button type="button" className="btn btn-tablet-color w-100 mb-2" disabled>
                                <i className="bi bi-upc-scan"></i> {t("entryWithBooking.scanButton", language)}
                            </button>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>{t("ModalBooking.driverTitleForm", language)}  <b className="required-bullet">*</b></Form.Label>
                        <div style={{ position: 'relative' }}>
                            {createAutoCompleteGeneric({
                                objName: "Yms_Booking",
                                rowIndex: null,
                                disabledFieldsFlg: props.disabledFieldsFlg,
                                columnConfig: {
                                    descr: "οδηγό",
                                    columnName: "YmsDri1.Name1",
                                    dropDownDisplay: "Name1",
                                    lookUpQuery: "{Yms_Drivers{DriverId Name1 DriverCode}}",
                                    secondaryField: "YmsDri1.DriverCode"
                                },
                                objectName: "Yms_Drivers",
                                instanceName: "m_yms_drivers",
                                lookupPrimaryField: "Name1",
                                lookupSecondaryField: "DriverCode",
                                setFieldsInBookingObj: (tmpObj, newEntry) => {
                                    tmpObj["Obj"].YmsDri1.Name1 = newEntry.Name1;
                                    tmpObj["Obj"].DriverId = newEntry.DriverId;
                                    tmpObj["Obj"].YmsDri1.DriverCode = newEntry.DriverCode;
                                }
                            })
                            }
                            {hasDriverBan && (
                                <div style={{
                                    position: 'absolute',
                                    top: '42%',
                                    right: '10px',
                                    transform: 'translateY(-50%)',
                                    color: '#dc3545',
                                    fontSize: '1.2rem',
                                    pointerEvents: 'none'
                                }}>
                                    <i className="bi bi-exclamation-lg"></i>
                                </div>
                            )}
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("ModalBooking.phoneTitleForm", language)}</Form.Label>
                        {createTextBox(bookingObj.Obj, "Phone", "Yms_Booking", null)}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("entryWithBooking.stampTitleForm", language)}</Form.Label>
                        {createCheckBox(bookingObj.Obj, "StampFlg", "Yms_Booking", null)}
                    </Form.Group>
                    <div className="header-form-new-booking m-0">
                        <h2>{t("ModalBooking.actionsHeader", language)}  <b className="required-bullet">*</b></h2>
                    </div>
                    <div className="tasks-container">
                        {bookingObj["Yms_BookingTasks"]?.length > 0 ? (
                            bookingObj["Yms_BookingTasks"].map((task, index) => (
                                <div className="task-item" key={task.BookingTaskId || index}>
                                    <div className="task-header">
                                        <span>
                                            <strong>{t('ModalBooking.actionsHeader', language)}: </strong>
                                            {
                                                task?.YmsTas1?.Descr1 || task?.YmsCat1?.Descr1 || task?.CountOfItems || task?.Pallets
                                                    ? [
                                                        task?.YmsTas1?.Descr1,
                                                        task?.YmsCat1?.Descr1,
                                                        task?.CountOfItems ? `${t('ModalBooking.itemCountTitleForm', language)}(${task.CountOfItems})` : null,
                                                        task?.Pallets ? `${t('ModalBooking.palletCountTitleForm', language)}(${task.Pallets})` : null
                                                    ].filter(Boolean).join(', ')
                                                    : t('ModalBooking.newTaskLabel', language)
                                            }
                                        </span>
                                        <span className="delete-icon" onClick={(e) => { e.stopPropagation(); deleteTask(index); }}>
                                            <i className="bi bi-ban"></i>
                                        </span>
                                    </div>
                                    <Form className="mb-3">
                                        <Form.Group>
                                            <Form.Label>
                                                {t("ModalBooking.taskLabel", language)} <span className="required-bullet">*</span>
                                            </Form.Label>
                                            {createDropDownLookUpList(task, "YmsTas1.Descr1", "Yms_BookingTasks", index)}
                                        </Form.Group>
                                    </Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.categoryTitleForm', language)}</Form.Label>
                                        {createDropDownLookUpList(task, "YmsCat1.Descr1", "Yms_BookingTasks", index)}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.itemCountTitleForm', language)}</Form.Label>
                                        {createTextBox(task, "CountOfItems", "Yms_BookingTasks", index)}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('ModalBooking.palletCountTitleForm', language)}</Form.Label>
                                        {createTextBox(task, "Pallets", "Yms_BookingTasks", index)}
                                    </Form.Group>
                                    <hr />
                                </div>
                            ))
                        ) : (
                            <p className="text-muted">{t("calendarEvent.noActionsAdded", language)}</p>
                        )}


                        {!props.disabledFieldsFlg && (
                            <Button className="button-add-task" style={{ marginBottom: "25px" }} onClick={addTask}>
                                <i className="bi bi-plus-circle"></i>  {t("ModalBooking.addTaskButton", language)}
                            </Button>
                        )}

                    </div>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("entryWithBooking.commentTitleForm", language)}</Form.Label>
                        {createTextBoxCommends(bookingObj.Obj, "Notes", "Yms_Booking", null)}
                    </Form.Group>
                </Form>

                <PhotoUpload
                    ref={photoUploadRef}
                    photoUrl={getPropValue(bookingObj.Obj, "PhotoPath")}
                    onImagesChange={handleImagesChange}
                    language={language}
                    serverUrl={serverUrl}
                    userToken={props.userToken}
                />
            </>
            <Modal show={isSuppliersModalOpen} onHide={handleCloseSuppliersModal} size="xl" centered animation={true} backdrop="static"  >
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div style={{ zIndex: 9999 }}>
                        <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language}/>
                    </div>
                    <div className="mb-3 position-relative" style={{ zIndex: 1 }}>
                        <img src='/images/sup-photo-list.png' alt='Supplier List' style={{
                            maxWidth: '200px',
                            width: '100%'
                        }} />
                    </div>
                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <ListSuppliers
                            handleSelectSupplier={handleSelectSupplier}
                            findSelectSupplier={findSelectSupplier}
                            handleSaveSuppliers={handleSaveSuppliers}
                            userToken={props.userToken}
                            language={language}
                        />
                    </div>
                </Modal.Body>
            </Modal>

        </div >
    );
}

export default NewBookingForm;
